<template>
  <q-modal
    id="draftStudentModal"
    class="sl-modal"
    v-model="draftStudentModalOpen"
    :no-esc-dismiss="true"
    :no-backdrop-dismiss="true"
    :maximized="maximized"
    :content-css="{width: '1000px', height: '800px'}"
  >
    <q-inner-loading :visible="draftStudentsLoading">
        <q-spinner-puff color="primary" size="70"></q-spinner-puff>
    </q-inner-loading>
    <q-modal-layout>
      <q-toolbar slot="header">
        <q-toolbar-title>
          <q-icon name="fa fa-clipboard"/>
          Draft Student Review
        </q-toolbar-title>
        <q-icon @click.native="close()" name="clear"/>
      </q-toolbar>
      <div class="sl-row header-row full-height">
        <div class="sl-col-5 flex flex-center">
          <div class="q-pa-md" style="width: 90%; max-width: 500px;">
            <h6 class="q-mb-md text-center">Student {{ currentIndex + 1 }} of {{ draftStudents.length }}</h6>
            <div v-if="draftStudents.length > 0">
              <div class="row q-mb-sm">
                <q-input
                  v-model="draftStudents[currentIndex].DL_NUMBER"
                  float-label="Drivers License #"
                  class="col-7 q-mr-sm"
                  autofocus
                />
                <q-select
                  v-model="draftStudents[currentIndex].DL_STATE"
                  :options="stateOptions"
                  float-label="Drivers License State"
                  outlined
                  emit-value
                  map-options
                  transition-show="scale"
                  transition-hide="scale"
                  class="col"
                />
              </div>
              <div class="row q-mb-sm">
                <q-input
                  v-model="draftStudents[currentIndex].FIRST_NAME"
                  float-label="First Name"
                  class="col q-mr-sm"
                />
                <q-input
                  v-model="draftStudents[currentIndex].LAST_NAME"
                  float-label="Last Name"
                  filled
                  class="col q-mr-sm"
                />
                <q-input
                  v-model="draftStudents[currentIndex].MIDDLE_NAME"
                  float-label="Middle Name"
                  filled
                  class="col"
                />
              </div>
              <div data-draft-address class="row q-mb-sm items-end">
                <q-input
                  v-model="draftStudents[currentIndex].ADDRESS1"
                  float-label="Address"
                  filled
                  class="col q-mr-sm"
                  @blur="onAddressBlur"
                />
                <q-input
                  v-model="draftStudents[currentIndex].ADDRESS2"
                  float-label="Address 2"
                  filled
                  class="col-3 q-mr-sm"
                  @blur="onAddressBlur"
                />
                <address-verify-chip
                  :address="currentAddress"
                  class="q-mb-xs"
                  @accept="onAcceptAddress"
                />
              </div>
              <div data-draft-address class="row q-mb-sm">
                <q-input
                  v-model="draftStudents[currentIndex].CITY"
                  float-label="City"
                  filled
                  class="col q-mr-sm"
                  @blur="onAddressBlur"
                />
                <q-select
                  v-model="draftStudents[currentIndex].STATE"
                  :options="stateOptions"
                  float-label="State"
                  outlined
                  emit-value
                  map-options
                  transition-show="scale"
                  transition-hide="scale"
                  filled
                  class="col-2 q-mr-sm"
                  @change="onAddressBlur"
                />
                <q-input
                  v-model="draftStudents[currentIndex].ZIP"
                  float-label="Zip"
                  filled
                  class="col-3"
                  @blur="onAddressBlur"
                />
              </div>
              <div class="row q-mb-sm">
                <q-select
                  v-model="draftStudents[currentIndex].GENDER"
                  :options="genderOptions"
                  float-label="Gender"
                  outlined
                  emit-value
                  map-options
                  transition-show="scale"
                  transition-hide="scale"
                  class="col-3 q-mr-sm"
                />
                <q-input
                  error-message="MM/DD/YYYY"
                  :error="fieldHasError('DOB')"
                  :before="[{icon: 'calendar_today' }]"
                  v-model="draftStudents[currentIndex].DOB"
                  float-label="Date of Birth"
                  filled
                  format="MM/DD/YYYY"
                  @blur="dateBlur"
                  class="col q-mr-sm"
                />
                <q-input
                  v-model="draftStudents[currentIndex].PHONE"
                  float-label="Phone"
                  filled
                  class="col"
                />
              </div>
              <div class="row q-mb-sm justify-center">
                <q-input
                  error-message="MM/DD/YYYY"
                  :error="fieldHasError('COMPLETION_DATE')"
                  :before="[{icon: 'calendar_today' }]"
                  v-model="draftStudents[currentIndex].COMPLETION_DATE"
                  float-label="Completion Date"
                  filled
                  class="col-6 q-mr-sm"
                  format="MM/DD/YYYY"
                />
              </div>

              <div class="row justify-center q-mt-lg">
                <q-btn
                  :disable="currentIndex === 0 || studentHasError"
                  color="primary"
                  icon="arrow_back"
                  label="Previous"
                  @click="previousStudent"
                  class="q-mr-md"
                  outline
                />
                <q-btn
                  :disable="currentIndex === draftStudents.length - 1 || studentHasError"
                  color="primary"
                  icon-right="arrow_forward"
                  outline
                  label="Next"
                  @click="nextStudent"
                />
              </div>
            </div>
            <div v-else class="text-center">
              No students to review
            </div>
          </div>
        </div>
        <div class="sl-col-7 full-height">
          <iframe
            v-if="foundDocument"
            ref="rosterFrame"
            style="width: 100%; height: 100%"
          ></iframe>
          <div v-else class="flex flex-center full-height">Could not find roster</div>
        </div>
      </div>
      <q-toolbar slot="footer" class="sl-footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn
          class="q-mr-sm"
          color="green" 
          @click="completeReview()"
          label="Finish"
          :disable="draftStudentsLoading"
        />
        <q-btn
          class="q-mr-sm"
          color="primary"
          @click="saveAndClose()"
          label="Save & Close"
          :disable="draftStudentsLoading"
        />
        <q-btn
          outline
          color="faded"
          @click="close()"
          label="Cancel"
        />
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { notify } from 'src/plugins/notify'
import { isDate, } from 'src/utils/validators'
import AddressVerifyChip from 'components/Shared/AddressVerifyChip'
import { draftAddress, isCheckable } from 'src/utils/addressVerification'

export default {
  name: 'JobModal',
  components: {
    AddressVerifyChip,
  },
  async mounted() {
    const rosterFrame = this.$refs.rosterFrame
    if (this.job.DOCUMENT) {
      const url = await this.getDocumentURL(this.job.DOCUMENT)
      rosterFrame.src = url
    } else {
      this.foundDocument = false
    }
  },
  data() {
    return {
      maximized: true,
      foundDocument: true,
      currentIndex: 0,
      genderOptions: [
        { label: 'Male', value: 0 },
        { label: 'Female', value: 1 },
        { label: 'Unidentified', value: 2 },
      ],
    }
  },
  computed: {
    ...mapState('jobs', {
      job: s => s.currentJob,
      draftStudents: s => s.draftStudents,
      draftStudentsLoading: s => s.draftStudentsLoading,
      draftStudentModalOpen: s => s.draftStudentModalOpen,
    }),
    ...mapState({
      states: s => s.shared.states,
      stateOptions: s => s.shared.states.map(s => ({ label: s.STATE, value: s.STATE, }))
    }),
    currentAddress() {
      return draftAddress(this.draftStudents[this.currentIndex], this.states)
    },
    studentHasError() {
      return this.$v.draftStudents.$each[this.currentIndex].$invalid
    },
  },
  methods: {
    ...mapMutations('jobs', [
      'setJobModalOpen',
      'setDraftStudentModalOpen',
      'setDraftStudentsLoading',
    ]),
    ...mapActions('jobs', [
      'saveDraftStudents',
      'fetchDraftStudents',
      'complete'
    ]),
    ...mapActions('addressVerification', {
      checkAddress: 'check'
    }),
    /**
     * Check the address with Google once focus leaves the address fields.
     * Finish checks every draft anyway; this is so the chip says up front
     * which ones Google cannot confirm or would correct.
     */
    onAddressBlur() {
      setTimeout(() => {
        if ($(document.activeElement).closest('[data-draft-address]').length) return
        const address = this.currentAddress
        if (!isCheckable(address) || !String(address.zip || '').trim()) return
        this.checkAddress({ address })
      }, 200)
    },
    onAcceptAddress(suggestion) {
      const draft = this.draftStudents[this.currentIndex]
      const state = this.states.find(s => s.LK_STATE_ID === suggestion.stateId)
      draft.ADDRESS1 = suggestion.address1
      draft.ADDRESS2 = suggestion.address2 || ''
      draft.CITY = suggestion.city
      if (state) draft.STATE = String(state.STATE).trim()
      draft.ZIP = suggestion.zip
    },
    ...mapActions('documents', [
      'getDocumentURL',
    ]),
    toggleMaximized(){
        this.maximized = !this.maximized
    },
    close() {
      this.setDraftStudentModalOpen(false)
    },
    async saveAndClose() {
      this.setDraftStudentsLoading(true)
      await this.save()
      this.setDraftStudentsLoading(false)

      notify.create({
        message: 'Saved draft students',
        type: 'positive'
      })

      this.$root.$emit('refreshGrid:jobsGrid')
      this.close()
      this.setJobModalOpen(false)
    },
    save() {
      return this.saveDraftStudents()
    },
    async completeReview() {
      this.setDraftStudentsLoading(true)
      await this.save()
      const result = await this.complete()
      this.setDraftStudentsLoading(false)

      if (!result) {
        notify.create({
          message: 'Could not finish the review. Nothing was imported.',
          type: 'negative'
        })
        return
      }

      this.$root.$emit('refreshGrid:jobsGrid')

      // Every draft is imported. Addresses Google corrected were imported in
      // the corrected form; ones it could not confirm are flagged on the
      // class for an admin to see when approving.
      const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`
      const notes = []
      if (result.corrected) notes.push(`${plural(result.corrected, 'address was', 'addresses were')} corrected by Google`)
      if (result.unverified) notes.push(`${plural(result.unverified, 'address', 'addresses')} could not be validated`)
      if (result.unchecked) notes.push(`${plural(result.unchecked, 'address', 'addresses')} could not be checked`)

      notify.create({
        message: `Finished student review! Imported ${plural(result.imported, 'student', 'students')}.`
          + (notes.length ? ` ${notes.join('; ')}.` : ''),
        type: notes.length ? 'info' : 'positive',
        timeout: notes.length ? 10000 : undefined
      })
      this.close()
      this.setJobModalOpen(false)
    },
    nextStudent() {
      if (this.currentIndex < this.draftStudents.length - 1) {
        this.currentIndex++;
      }
    },
    previousStudent() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    dateBlur() {
      this.$v.draftStudents.$each[this.currentIndex].$touch()
    },
    fieldHasError(field) {
      return this.$v.draftStudents.$each[this.currentIndex][field].$error
    }
  },
  validations() {
    function validDateOrBlank(d) {
      return d === "" || d === null || isDate(d)
    }
    return {
      draftStudents: {
        $each: {
          DOB: { validDateOrBlank, },
          COMPLETION_DATE: { validDateOrBlank, },
        }
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~variables';

#jobModal {
  .section-header {
    margin-top: 30px;
    margin-bottom: 10px;

    h5 {
      margin-top: 0;
    }

    .label {
      &.small {
        margin: 0 7px 7px 0;
      }
    }
  }

  .modal-content {
    max-height: 100%;
  }
  .sl-table{
    border-radius: 8px 8px 0 8px  
  }
  .sl-footer {
    .q-btn {
      margin-left: 5px;
    }
  }

  .order-details-wrapper {
    margin: 25px 20px;
  }

  .pull-right {
    float: right;
  }

  .header-row {
    background: #eee;
    border-bottom: 1px solid border-color;

    .sl-col-4 {
      padding: 40px 30px;
      border-right: 1px solid border-color;
      position: relative;
      font-weight: 600;
      font-size: 17px;
      height: 130px;

      .q-icon {
        top: 30%;
        font-size: 40px;
        position: absolute;
        right: 20px;
        color: #b9b9b9;
      }

      label {
        font-weight: 400;
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
        display: block;
        margin: 0 0 5px;
      }
    }

    .label {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
    }
  }

  .meta {
    margin: 0 0 60px;

    .pull-left {
      float: left;
    }

    .text-label {
      font-weight: 600;
      font-size: 13px;
      letter-spacing: 1px;
      text-transform: uppercase;
      display: inline-block;
      margin: 0 0 5px;
    }
    .total{
      float: right;
      padding: 13px 29px;
      background: #dadada;
      border-radius: 0 0 7px 7px;
    }
  }

  .order-total {
    color: #000;

    i {
      font-size: 13px;
      color: #bbb;
    }
  }
  .full-height {
    height: 100%;
  }
}

</style>
